import { PATHS } from '@tom-ui/utils'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import PortDefense from './PortDefense'

export const PortDefensePage: FC = () => {
  const navigate = useNavigate()
  return <PortDefense onClose={() => navigate(PATHS.arcade.url)} />
}
